export default {
  title01: "Cari Hava",
  title02: "24 Saat",
  title03: "10 Günlük Hava Proqnozuna Baxın",
  title04: "Hava Keyfiyyəti İndeksi",
  title05: "Bütün Məlumatlara Baxın",
  title06: "Günəşin Doğuşu və Batışı",
  title07: "Ayın Fazaları",
  title08: "Növbəti Tam Ay",
  title09: "Növbəti Yeni Ay",
  title10: "GÜN",
  title11: "GECƏ",
  title12: "Günəşin çıxması",
  title13: "Günəşin batması",
  title14: "Ayın çıxması",
  title15: "Ayın batması",
  title16: "Mənbə",
  title17: "Başla",
  title18: "Bitir",
  title19: "Cari Məkanı İstifadə et",
  title20: "Şəhəri Axtar",
  title21: "Hiss Edilən Temperatur",
  title22: "Kölgədə Hiss Edilən Temperatur",
  title23: "İndi",
  title24: "Bu gün",
  title25: "Bazar",
  title26: "Bazar ertəsi",
  title27: "Çərşənbə axşamı",
  title28: "Çərşənbə",
  title29: "Cümə axşamı",
  title30: "Cümə",
  title31: "Şənbə",
  title32: "Yüklənir...",
  title33: "İndi",
  title34: "Saatlıq",
  title35: "Gündəlik",
  title36: "Günəş & Ay",
  title37: "Hava Keyfiyyəti",
  title38: "Əlaqə: xlf550402@gmail.com",
  title39: "Məxfilik Müqaviləsi",
  title40: "Müəllif Hüquqları © comfortweather.com 2020 - 2026. Bütün Hüquqlar Qorunur.",
  title41: "Məlumatı Təmin edən:",
  title42: "Salam",
  title43: "Aşağı Temperatur",
  title44: "Qəbul et",
  title45:
    "ComfortWeather-dən istifadə etdiyiniz üçün təşəkkür edirik! Hüquq və maraqlarınızı daha yaxşı qorumaq üçün istifadədən əvvəl ",
  title46: "Məxfilik Siyasəti",
  title47: " ni diqqətlə oxuyun.",
  title48: "",
  title49: "Əlaqə: xyjph123@gmail.com",
  title50: "Müəllif Hüquqları © 24hweather.com 2020 - 2026. Bütün Hüquqlar Qorunur.",
  title51:
    "24hweather-dən istifadə etdiyiniz üçün təşəkkür edirik! Hüquq və maraqlarınızı daha yaxşı qorumaq üçün istifadədən əvvəl ",
  title52: "Your location has changed. Would you like to update it?",
  title53: "Confirm",
  title54: "Cancel",
  title55: "Back",
  title56: "News",
  title57: "Updating weather...",
  title58: "Weather updated",
  title59: "View All",
  title60: "Müəllif Hüquqları © mobi321.com 2020 - 2026. Bütün Hüquqlar Qorunur.",
  title61: "Yesterday",
  title62: "Tomorrow",
  title63: "15 Günlük Hava Proqnozuna Baxın",
  title64: "Today's details",
};
